import { all } from 'redux-saga/effects';
import registerWatcher from './register';
import loginWatcher from './login';
import userMgmtWatcher from './users';
import roleMgmtWatcher from './roles';
import projectMgmtWatcher from './projects';
import forecastWatcher from './forecast';
import budgetWatcher from './project_budget';
import costTrackingWatcher from './cost_tracking';
import claimWatcher from './claim';
import taskWatcher from './task';
import variationRegisterWatcher from './variation_register';
import paymentActWatcher from './payment_act';
import segmentWatcher from './segment';
import dashboardWatcher from './dashboard';
import reportWatcher from './report';
import managementDashboardWatcher from './management_dashboard';
import costCodeWatcher from './cost_code';
import estimationSheetWatcher from './estimation_sheet_import';
import costCodeImportWatcher from './cost_code_import';
import resourceCodeWatcher from './resource_code';
import resourceCodeImportWatcher from './resource_code_import';
import resourceAssignerWatcher from './resource_assigner_bulk_import';

function* rootSaga() {
  yield all([
    registerWatcher(),
    loginWatcher(),
    userMgmtWatcher(),
    roleMgmtWatcher(),
    projectMgmtWatcher(),
    budgetWatcher(),
    forecastWatcher(),
    costTrackingWatcher(),
    claimWatcher(),
    taskWatcher(),
    variationRegisterWatcher(),
    paymentActWatcher(),
    segmentWatcher(),
    dashboardWatcher(),
    reportWatcher(),
    managementDashboardWatcher(),
    costCodeWatcher(),
    estimationSheetWatcher(),
    costCodeImportWatcher(),
    resourceCodeWatcher(),
    resourceCodeImportWatcher(),
    resourceAssignerWatcher(),
  ]);
}

export default rootSaga;
